import React, { useState, useEffect } from "react";
import axios from "axios";
import { Spin, Modal } from "antd";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

  const API_BASE = process.env.REACT_APP_API_BASE;

function Sofa() {
  const [sofas, setSofas] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [loading, setLoading] = useState(true);
  const [previewSofa, setPreviewSofa] = useState(null);

  // Fetch sofas from backend
  useEffect(() => {
    const fetchSofas = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`${API_BASE}/service/readAllService`);
        const data = Array.isArray(res.data.data.services) ? res.data.data.services : [];
        const sofaItems = data.filter((item) => item.category === "Sofa Collection");
        setSofas(sofaItems);
        setFiltered(sofaItems);
      } catch (err) {
        console.error("Failed to load sofas:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchSofas();
  }, []);


  return (
    <div className="max-w-7xl mx-auto mt-10 mb-16 px-4">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-10" style={{ color: "#1A8F5A" }}>
        Sofa Collection
      </h2>

    

      {loading ? (
        <div className="flex justify-center items-center py-20">
          <Spin size="large" />
        </div>
      ) : filtered.length === 0 ? (
        <p className="text-center text-gray-500">No sofas available.</p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6">
          {filtered.map((item) => (
            <motion.div
              key={item._id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              viewport={{ once: true }}
              className="rounded-xl overflow-hidden border cursor-pointer relative group"
              style={{
                background: "#FFFFFF",
                border: "1px solid #E5E7EB",
                boxShadow: "0 8px 20px rgba(18,24,30,0.04)",
              }}
              onClick={() => setPreviewSofa(item)}
            >
              <img
                src={item.image || "https://source.unsplash.com/400x300/?sofa,livingroom"}
                alt={item.name}
                className="w-full h-48 object-cover transition-transform duration-300 group-hover:scale-105"
              />
            </motion.div>
          ))}
        </div>
      )}

      {/* Preview Modal (like Ourcleaning.jsx) */}
      <Modal
        open={!!previewSofa}
        onCancel={() => setPreviewSofa(null)}
        footer={null}
        centered
        width={900}
        bodyStyle={{ maxHeight: "90vh", overflowY: "auto" }}
      >
        {previewSofa && (
          <div className="flex flex-col md:flex-row gap-6 items-start" style={{ fontFamily: "var(--font-body)" }}>
            <div className="md:w-2/3 w-full h-96 overflow-hidden">
              <img
                src={previewSofa.image || "https://source.unsplash.com/900x700/?sofa,livingroom"}
                alt={previewSofa.name}
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
            <div className="md:w-1/3 w-full flex flex-col justify-center">
              <h3
                className="text-3xl font-bold mb-4"
                style={{ color: "#1A8F5A", fontFamily: "var(--font-heading)" }}
              >
                {previewSofa.name}
              </h3>
              <p className="text-gray-700 mb-6">{previewSofa.description}</p>
              <Link to="/FilteredBook">
                <button
                  className="px-6 py-3 rounded font-semibold"
                  style={{ background: "#1A8F5A", color: "#FFFFFF" }}
                >
                  Select the Provider
                </button>
              </Link>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
}

export default Sofa;
